
import React, { useState, useRef, useLayoutEffect, useEffect } from 'react'

import each from 'lodash/each'

import classNames from 'classnames'

import styles from './tabbed_content.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Title from './basic/title'

import library from './library'


function TabbedContent(props) {
	const tabsRef = useRef(null)
    const fields = props.fields
    const isMobileInit = typeof window !== 'undefined' && window.innerWidth < 768
    const firstNonLinkIndex = fields.items.findIndex((it) => !it.direct_link)
    const initialActiveIndex = isMobileInit
        ? (firstNonLinkIndex > -1 ? firstNonLinkIndex : 0)
        : 0
    const tabbedItems = fields.items.map((item, index) => {
        return { ...item, active: index === initialActiveIndex }
    })
	const [state, setState] = useState({items: tabbedItems})
	const refreshHeight = useRef(null)
 

    // desktop already handled via initialActiveIndex

	const handleItemClick = (el, index) => {
		el.preventDefault()

		const tabbedItems = state.items

		if(window.innerWidth < 768) {
			const tabbedContentInner = tabsRef.current.querySelectorAll(`.${styles.body}`)[index]

			if (refreshHeight.current) {
				clearTimeout(refreshHeight.current)
			}

			if (tabbedItems[index].active == true){
				tabbedItems[index].active = false
				tabbedContentInner.style.height = '0px'
			} else {
				tabbedItems[index].active = true
				tabbedContentInner.style.height = tabbedContentInner.scrollHeight + 'px'

				//double-check height after content loads
				refreshHeight.current = window.setTimeout(() => {
					tabbedContentInner.style.height = tabbedContentInner.scrollHeight + 'px'
				}, 750)
			}
		} else {
			each(tabbedItems, (item, i) => {
				tabbedItems[i].active = false
			})

			tabbedItems[index].active = true
		}

		setState({items: tabbedItems})
	}

	useLayoutEffect(() => {
		if(window.innerWidth > 768) {
			const contentItems = tabsRef.current.querySelectorAll(`.${styles.content}`)
			const blockWrapper = tabsRef.current.querySelector(`#wrapper`)
			
			// Remove fixed height calculation to allow content expansion
			// Instead, let the content determine its own height naturally
			blockWrapper.style.height = 'auto'
			blockWrapper.style.minHeight = '0'
			blockWrapper.style.maxHeight = 'none'
			blockWrapper.style.overflow = 'visible'
		}
	}, [])

 

useEffect(() => {
    // Ensure mobile heights reflect initial active state
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768
    if (!isMobile || !tabsRef.current) return
    const bodies = tabsRef.current.querySelectorAll(`.${styles.body}`)
    requestAnimationFrame(() => {
        state.items.forEach((it, idx) => {
            const el = bodies[idx]
            if (!el) return
            el.style.height = it.active ? (el.scrollHeight + 'px') : '0px'
        })
    })
}, [])

// Ensure mobile bodies expand/collapse in sync with state changes
useEffect(() => {
    const isMobile = window.innerWidth < 768
    if (!isMobile || !tabsRef.current) return
    const bodies = tabsRef.current.querySelectorAll(`.${styles.body}`)
    // Defer to ensure DOM reflects new state
    requestAnimationFrame(() => {
        state.items.forEach((it, idx) => {
            const el = bodies[idx]
            if (!el) return
            if (it.active) {
                el.style.height = el.scrollHeight + 'px'
            } else {
                el.style.height = '0px'
            }
        })
    })
}, [state.items])
	
	return <div ref={tabsRef} className={classNames(styles.tabbed_content)}>
			<ScrollAnimation styles={styles}>
				<BlockWrapper {...props} id="wrapper">
					<div className={classNames(styles.tabs_wrapper)}>
						<div className={classNames(styles.title_wrapper)}>
							{fields.title && <Title fields={fields.title} className={styles.title} />}
							<div className={styles.tabs}>
							{state.items.map((item, i) => {
								const isDirectLink = !!item.direct_link
								const target = item.open_new_window ? '_blank' : undefined
								const rel = item.open_new_window ? 'noopener noreferrer' : undefined
								return (
									<div
										className={classNames(styles.title, item.active == true ? styles.active : '')}
										key={i}
										{...(isDirectLink ? {} : { onClick: (e) => handleItemClick(e, i) })}
									>
										{isDirectLink ? (
											<a href={item.url} target={target} rel={rel}>
												<h3>{item.title}</h3>
											</a>
										) : (
											<h3>{item.title}</h3>
										)}
									</div>
								)
							})}
							</div>
						</div>
						<div className={classNames(styles.content_wrapper)}>
							{state.items.map((item, i) => {
								const renderedComponents = []

								each(item.content, (component, i) => {
									const type = component.acf_fc_layout
			
									const Component = library[type];
									const renderedComponent = <Component key={`component_${type}_${i}`} fields={component} tabbed_content={true} active={item.active} />
			
									renderedComponents.push(renderedComponent)
								})

								return <div className={classNames(styles.content, item.active == true ? styles.active : '')} key={i}>
									<div
										className={classNames(styles.content_title, item.active == true ? styles.active : '')}
										{...(item.direct_link ? {} : { onClick: (e) => handleItemClick(e, i) })}
									>
										{item.direct_link ? (
											<a href={item.url} target={item.open_new_window ? '_blank' : undefined} rel={item.open_new_window ? 'noopener noreferrer' : undefined}>
												<h3>{item.alternate_title_mobile ? item.alternate_title_mobile : item.title}</h3>
											</a>
										) : (
											<h3>{item.alternate_title_mobile ? item.alternate_title_mobile : item.title}</h3>
										)}
									</div>
									<div className={styles.body}>
										<div className={styles.body_inner}>
											{renderedComponents}
										</div>
									</div>
								</div>
							})}
						</div>
					</div>
				</BlockWrapper>
			</ScrollAnimation>
	</div>
}

export default TabbedContent